import React from 'react';

const DesainErgonomisHardwareInovasi: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p className="mb-4">
        Banyak proyek inovasi teknologi yang memiliki rangkaian sensor elektronik brilian dan kode program yang sempurna, namun gugur dalam penilaian juri karena perakitan perangkat keras yang rapuh: kabel jumper yang berserakan, sambungan baterai longgar, dan tidak adanya pelindung dari debu atau percikan air.
      </p>

      <p className="mb-4">
        Dalam ajang <b>Innovative Technology Challenge</b>, aspek <b>Product Packaging and Enclosure Design</b> menjadi faktor penentu kematangan prototipe sebelum dipertimbangkan layak uji di lingkungan nyata.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Prinsip Rancang Bangun Casing 3D Printing
      </h2>
      <ul className="list-disc pl-6 mb-6 space-y-3">
        <li>
          <strong>Pemilihan Filamen yang Tepat:</strong> Menggunakan filamen PETG atau ABS untuk perangkat luar ruangan karena ketahanannya terhadap panas matahari tropis dan kelembaban, dibandingkan filamen PLA standar yang mudah melengkung.
        </li>
        <li>
          <strong>Ventilasi dan Manajemen Termal:</strong> Menyisipkan lubang kisi ventilasi (<i>ventilation slits</i>) dan heat sink mini di sekitar mikrokontroler dan modul regulator tegangan untuk mencegah panas berlebih (<i>overheating</i>).
        </li>
        <li>
          <strong>Penyegelan Tahan Air (Weatherproofing):</strong> Menambahkan lekukan dudukan karet silikon (<i>gasket</i>) dan lubang keluaran kabel bersegel (<i>cable gland</i>) untuk melindungi sirkuit internal dari tetesan air hujan.
        </li>
        <li>
          <strong>Aksesibilitas Perawatan:</strong> Merancang penutup dengan pengunci baut kuningan (<i>brass threaded inserts</i>) agar baterai atau kartu SD dapat diganti dengan mudah tanpa merusak ulir plastik.
        </li>
      </ul>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Kesan Pertama yang Meyakinkan Juri
      </h2>
      <p className="mb-4">
        Casing perangkat yang dirancang ergonomis, kokoh, dan berlabel keterangan port yang jelas memberikan kesan bahwa inovasi tersebut bukan lagi sekadar eksperimen mainan laboratorium, melainkan produk rekayasa matang yang siap diproduksi dan dimanfaatkan oleh masyarakat luas.
      </p>
    </div>
  );
};

export default DesainErgonomisHardwareInovasi;
